import React from "react";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";

import classes from "./Textarea.module.css";

interface Props {
  label: string;
  supportLabel: string;
  placeholder: string;
  elementLabelStyle: {};
  elementInputStyle: {};
  name: string;
  errorText: string;
  value: string;
  onChange: (event) => void;
}

const textarea: React.FunctionComponent<Props> = (props) => {
  const {
    label,
    supportLabel,
    placeholder,
    elementLabelStyle,
    elementInputStyle,
    name,
    errorText,
    value,
    onChange,
  } = { ...props };
  return (
    <FormGroup className={classes.formGroup}>
      <FormLabel style={elementLabelStyle} className={classes.formLabel}>
        {label}
        <small>{supportLabel}</small>
      </FormLabel>
      <FormControl
        as="textarea"
        placeholder={placeholder}
        style={elementInputStyle}
        className={classes.controlCustom}
        name={name}
        value={value}
        onChange={onChange}
      />
      <span className={classes.errorMsg}>{errorText}</span>
    </FormGroup>
  );
};
export default textarea;
